import { useEffect, useState } from "react";

/**
 * 入力のたびに API を叩かないよう、値の変化を一定時間まとめる。
 * 入力候補の取得で使用する。
 */
export function useDebouncedValue<T>(value: T, delayMs = 200): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
